import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useState } from 'react';

import {
  HostingSiteAddBody,
  HostingSiteAddV2200,
} from '@newfold/huapi-js/src/index.schemas';

import useAccount from '~/hooks/useAccount';
import useHostingNavigate from '~/hooks/useHostingNavigate';
import { AddSiteFormDataTypes } from '~/scenes/AddSetupSiteFlows';
import BtnGroup from '~/scenes/AddSetupSiteFlows/components/MultiStepCard/BtnGroup';

import DomainFormWithCTB from './DomainFormWithCTB';

type ConnectDomainWithCTBPropOptions = {
  formData?: AddSiteFormDataTypes;
  setFormData?: (state: AddSiteFormDataTypes | any) => void;
  createWebsite?: UseMutateFunction<
    AxiosResponse<HostingSiteAddV2200, any>,
    AxiosError<unknown, any>,
    {
      hostingId: string;
      data: HostingSiteAddBody;
    },
    void
  >;
  changeLoading?: boolean;
  isSiteAddPending?: boolean;
  isLoadingDomainAvailability?: boolean;
  handleSubmit?: () => void;
};

const ConnectDomainWithCTB = ({
  formData = {},
  setFormData = () => {},
  createWebsite = () => {},
  changeLoading = false,
  isSiteAddPending = false,
  isLoadingDomainAvailability = false,
  handleSubmit = () => {},
}: ConnectDomainWithCTBPropOptions) => {
  const { id: hostingId } = useAccount();
  const hostingNavigate = useHostingNavigate();
  const [error, setError] = useState(false);
  const [value, setValue] = useState(formData?.domain);

  // preventPath will change when a path is entered/removed by the user (see DomainForm logic)
  // It applies to basic hosting and generic site cases
  const [preventPath, setPreventPath] = useState(false);

  const handleSkipBtn = () => {
    createWebsite({
      hostingId,
      data: {
        title: formData.siteName,
        domain: '',
        path: '',
        subtype: formData.subtype!,
      },
    });
  };

  const handleContinueBtn = () => {
    if (formData?.autoGeneration) {
      handleSkipBtn();
    } else {
      handleSubmit();
    }
  };

  const handleCloseInstallModal = () => hostingNavigate();

  const disableCTA = () =>
    changeLoading ||
    preventPath ||
    (formData.domain === '' && !formData.autoGeneration) ||
    (error && value !== '');
  return (
    <DomainFormWithCTB
      formData={formData}
      setFormData={setFormData}
      preventPath={preventPath}
      setPreventPath={setPreventPath}
      error={error}
      setError={setError}
      value={value}
      setValue={setValue}
      disabled={isSiteAddPending || isLoadingDomainAvailability}
    >
      <BtnGroup
        hasSkipBtn
        onSkipHandler={handleSkipBtn}
        onClickHandler={handleContinueBtn}
        onCloseHandler={handleCloseInstallModal}
        disabled={disableCTA()}
        loading={changeLoading}
        domainChangeLoading={isSiteAddPending || isLoadingDomainAvailability}
        type={formData.subtype}
      />
    </DomainFormWithCTB>
  );
};

export default ConnectDomainWithCTB;
